import React, { useEffect, useState } from 'react';

import axios from 'axios';

import Paper from '@mui/material/Paper';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import 'moment/locale/ko';
import Box from '@mui/material/Box';
import { useForm } from 'react-hook-form';
import Pagination from '@mui/material/Pagination';
import Container from '@mui/material/Container';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import Checkbox from '@mui/material/Checkbox';

const columns = [
  { id: 'rowNumber', label: 'No', minWidth: 40, align: 'center' },
  { id: 'Company.companyName', label: '회사', minWidth: 100, align: 'center' },
  { id: 'userid', label: 'ID', minWidth: 140, align: 'center' },
  { id: 'username', label: '담당자 이름', minWidth: 100, align: 'center' },
  { id: 'eMail', label: '이메일', minWidth: 180, align: 'center' },
  { id: 'phoneNumber', label: '전화번호', minWidth: 180, align: 'center' },
  { id: 'cellPhoneNumber', label: '핸드폰번호', minWidth: 100, align: 'center' },
  { id: 'isActiveNm', label: '사용여부', minWidth: 100, align: 'center' },
  { id: 'lastLoginAt', label: '최근 접속일시', minWidth: 100, align: 'center' }
];

export default function UserMng() {
  const [srchData, setSrchData] = useState({ didas: false });
  const [datas, setDatas] = useState({ Role: { role: 'ROLE_USER' } });
  const [rows, setRows] = useState([]);
  const [pageCnt, setPageCnt] = useState(1);
  const [page, setPage] = useState(1);
  const [offset] = useState(10);

  const [roles, setRoles] = useState([]);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    reset,
    formState: { errors, isDirty }
  } = useForm({
    mode: 'all'
  });

  const handleChangeSrch = (e) => {
    let id = e.target.id.replace('Srch', '');
    setSrchData({ ...srchData, [id]: e.target.value });
  };

  const handleChange = (e) => {
    setDatas({ ...datas, [e.target.id]: e.target.value });
  };

  const handleChangeRole = (e) => {
    setDatas({ ...datas, Role: { role: e.target.value } });
  };

  const handleChangeIsActive = (e) => {
    setDatas({ ...datas, isActive: e.target.value });
  };

  const handleRowClick = (data) => (evt) => {
    initForm();
    setDatas(data);
    setValue('datas', data);
  };

  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const getDataList = async (e) => {
    const { userid, username, companyName, companyNo, didas } = srchData;
    let params = {
      offset,
      page,
      limit: offset,
      userid,
      username,
      companyName,
      companyNo,
      didas
    };

    const response = await axios.get(`/api/user`, { params });
    if (response.data) {
      const result = response.data;
      setPageCnt(Math.ceil(result.count / offset));
      setRows(result.rows);
      if (e?.target) {
        setPage(1);
      }
    }
  };

  const onClickInit = (evt) => {
    initForm();
  };

  const initForm = () => {
    setDatas({ Role: { role: 'ROLE_USER' } });
    clearErrors();
    reset();
  };

  const userInfoCreate = async (data) => {
    return await axios.post(`/api/user`, data);
  };

  const userInfoUpdate = async (data) => {
    return await axios.patch(`/api/user/${datas.id}`, datas);
  };

  const onClickDelete = async (evt) => {
    try {
      if (datas.id) {
        await axios
          .delete(`/api/user/${datas.id}`)
          .then((response) => {
            getDataList();
            initForm();
            alert(response.data.message);
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      }
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const onClickInitPassword = async (evt) => {
    try {
      if (datas.id) {
        await axios
          .patch(`/api/user/initpassword/${datas.id}`)
          .then((response) => {
            alert(response.data.message);
          })
          .catch((error) => {
            alert(error.response.data.message);
          });
      }
    } catch (e) {
      console.log(`insert failed`);
    }
  };

  const createOrUpdate = async () => {
    if (!!datas.id) {
      return await userInfoUpdate(datas);
    } else {
      return await userInfoCreate(datas);
    }
  };

  const isDuplicationUserid = async (e) => {
    await axios
      .get(`/api/user/isduplicationuserid/${datas.userid}`)
      .then((response) => {
        alert(response.data.message);
        if (response.data.Code) {
          setDatas({ ...datas, userid: '' });
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  const onSubmit = (data) => {
    if (isDirty) {
      createOrUpdate(data.datas)
        .then((response) => {
          getDataList();
          initForm();
          alert(response.data.message);
        })
        .catch((error) => {
          alert(error.response.data.message);
        });
    }
  };

  const getRoleCodeList = async () => {
    await axios
      .get(`/api/code/role`)
      .then((response) => {
        if (!!response.data) {
          setRoles(response.data);
        }
      })
      .catch((error) => {
        alert(error.response.data.message);
      });
  };

  useEffect(() => {
    getDataList(page);
  }, [page]);

  useEffect(() => {
    getRoleCodeList();
  }, []);

  return (
    <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
      <Typography component="h2" variant="h6" color="primary" gutterBottom>
        계정 관리
      </Typography>
      <Grid container spacing={2}>
        <Grid item xs={9}>
          <Stack direction="row" spacing={2}>
            <TextField id="companyNameSrch" variant="outlined" size="small" label="회사명" value={srchData?.companyName || ''} onChange={handleChangeSrch} />
            <TextField id="usernameSrch" variant="outlined" size="small" label="사용자명" value={srchData?.username || ''} onChange={handleChangeSrch} />
            <TextField id="useridSrch" variant="outlined" size="small" label="아이디" value={srchData?.userid || ''} onChange={handleChangeSrch} />
            <FormControlLabel
              control={<Checkbox />}
              id="didas"
              name="didas"
              label="디다스"
              onChange={(e) => {
                setSrchData({ ...srchData, didas: e.target.checked });
              }}
              checked={srchData?.didas}
              sx={{ ml: 1 }}
            />
            <Button variant="contained" onClick={getDataList}>
              검색
            </Button>
          </Stack>
          <TableContainer component={'div'}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  {columns.map((column) => (
                    <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                      {column.label}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row, rowIdx) => (
                  <TableRow hover key={row.id} onClick={handleRowClick(row)}>
                    {columns.map((col, colIdx) => (
                      <TableCell key={`row${rowIdx}-col${colIdx}`} align={col.align}>
                        {col.id.split('.').length != 1 ? eval('row.' + col.id.split('.')[0])[col.id.split('.')[1]] : row[col.id]}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <Container maxWidth="sm" sx={{ mt: 2 }}>
              <Pagination count={pageCnt} page={page} onChange={handleChangePage} showFirstButton showLastButton />
            </Container>
          </TableContainer>
        </Grid>
        <Grid item xs={3}>
          <Stack direction="row" spacing={2} justifyContent="flex-end">
            <Button variant="contained" onClick={onClickInit}>
              초기화
            </Button>
            <Button variant="contained" type="submit" form="userInfoForm" disabled={isDirty && JSON.stringify(datas) !== '{}' ? false : true}>
              {!!datas.id ? '수정' : '등록'}
            </Button>
            <Button variant="contained" onClick={onClickDelete} disabled={datas.id ? false : true}>
              삭제
            </Button>
          </Stack>
          <Box id="userInfoForm" component="form" onSubmit={handleSubmit(onSubmit)} noValidate sx={{ mt: 1, minWidth: 300, maxWidth: 500 }}>
            <TextField
              margin="dense"
              required
              sx={{ width: 2 / 3 }}
              id="userid"
              label="ID"
              name="userid"
              value={datas?.userid || ''}
              disabled={datas?.id && true}
              error={!!errors.datas?.userid}
              helperText={errors.datas?.userid && errors.datas?.userid.message}
              {...register('datas.userid', {
                required: 'ID를 입력해주세요.',
                minLength: { value: 5, message: 'ID는 5자 이상입니다.' },
                maxLength: { value: 20, message: 'ID는 20자 이하입니다.' },
                onChange: (e) => handleChange(e)
              })}
            />
            <Button variant="contained" onClick={isDuplicationUserid} size="large" sx={{ width: 0.8 / 3, ml: 2, mt: 1, fontSize: 12, height: 55 }} disabled={!!!datas.id && !!datas.userid ? false : true}>
              중복체크
            </Button>
            <TextField
              margin="dense"
              required={!datas?.id && true}
              name="password"
              label="비밀번호"
              type="password"
              id="password"
              value={datas?.password || ''}
              sx={{ width: 2 / 3 }}
              error={!!errors.datas?.password}
              helperText={errors.datas?.password && errors.datas?.password.message}
              {...register('datas.password', {
                required: !datas?.id && '비밀번호를 입력해주세요.',
                pattern: {
                  value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d~!@#$%^&*()+|=]{8,20}$/,
                  message: '비밀번호는 8자 이상, 최소 하나의 문자 및 숫자를 입력해주세요.'
                },
                onChange: (e) => handleChange(e)
              })}
            />
            <Button variant="contained" onClick={onClickInitPassword} sx={{ width: 0.8 / 3, ml: 2, mt: 1, fontSize: 12 }} disabled={!!datas.id ? false : true}>
              비밀번호 <br />
              초기화
            </Button>
            <TextField margin="dense" required fullWidth name="Company.companyName" label="회사명" id="Company.companyName" value={datas?.Company?.companyName || ''} disabled={true} />
            <TextField margin="dense" required fullWidth name="Company.companyNo" label="사업자등록번호" id="Company.companyNo" value={datas?.Company?.companyNo || ''} disabled={true} />
            <TextField
              margin="dense"
              required
              fullWidth
              name="username"
              label="담당자 이름"
              id="username"
              value={datas?.username || ''}
              error={!!errors.datas?.username}
              helperText={errors.datas?.username && errors.datas?.username.message}
              {...register('datas.username', {
                required: '담당자 이름을 입력해주세요.',
                onChange: (e) => handleChange(e)
              })}
            />
            <TextField
              margin="dense"
              required
              fullWidth
              name="eMail"
              label="E-mail"
              type="text"
              id="eMail"
              value={datas?.eMail || ''}
              error={!!errors.datas?.eMail}
              helperText={errors.datas?.eMail && errors.datas?.eMail.message}
              {...register('datas.eMail', {
                required: '이메일을 입력해주세요.',
                pattern: { value: /^\S+@\S+$/i, message: '이메일 형식을 확인해주세요' },
                onChange: (e) => handleChange(e)
              })}
            />
            <TextField
              margin="dense"
              required
              fullWidth
              name="phoneNumber"
              label="전화번호"
              id="phoneNumber"
              value={datas?.phoneNumber || ''}
              error={!!errors.datas?.phoneNumber}
              helperText={errors.datas?.phoneNumber && errors.datas?.phoneNumber.message}
              {...register('datas.phoneNumber', {
                required: '전화번호를 입력해주세요.',
                pattern: { value: /\d/, message: '숫자만 입력해주세요.' },
                onChange: (e) => handleChange(e)
              })}
            />
            <TextField
              margin="dense"
              required
              fullWidth
              name="cellPhoneNumber"
              label="핸드폰 번호"
              id="cellPhoneNumber"
              value={datas?.cellPhoneNumber || ''}
              error={!!errors.datas?.cellPhoneNumber}
              helperText={errors.datas?.cellPhoneNumber && errors.datas?.cellPhoneNumber.message}
              {...register('datas.cellPhoneNumber', {
                required: '핸드폰번호를 입력해주세요.',
                pattern: { value: /\d/, message: '숫자만 입력해주세요.' },
                onChange: (e) => handleChange(e)
              })}
            />
            <FormControl>
              <FormLabel required>권한</FormLabel>
              <RadioGroup name="role" id="role" value={datas.Role?.role || 'ROLE_USER'} onChange={handleChangeRole}>
                {roles.map((item, idx) => {
                  if (item.cdVal !== 'ROLE_ADMIN') {
                    return <FormControlLabel key={item.cdVal} value={item.cdVal} control={<Radio {...register('datas.Role.role')} />} label={item.cdNm} />;
                  }
                })}
              </RadioGroup>
              <FormLabel required>사용여부</FormLabel>
              <RadioGroup name="isActive" id="isActive" value={datas.isActive || false} onChange={handleChangeIsActive}>
                <FormControlLabel key="true" value={true} control={<Radio {...register('datas.isActive')} />} label="사용중" />
                <FormControlLabel key="false" value={false} control={<Radio {...register('datas.isActive')} />} label="미사용" />
              </RadioGroup>
            </FormControl>
          </Box>
        </Grid>
      </Grid>
    </Paper>
  );
}
